import { Component, OnInit,Renderer, ElementRef, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { Observable } from "rxjs/Observable";
import { CanComponentDeactivate, CanDeactivateGuardService } from "../shared/modals/modal-popup/can-deactivate-gaurd.service";
import { ModalPopupService } from '../shared/modals/modal-popup/modal-popup.service';
import { BootstrapDatePickerComponent } from '../shared/components/ng-date-picker.component';
import { EDIT_BTN, AssessmentSummary, DateUtility, SINGLE_ROW_HEADER, DELETE_BTN, AUDIT_BTN, AUDIT_ENTITY_ID, AUDIT_ENTITY_TYPE, AUDIT_ENTITY_COLUMN_DEFS, AUDIT_PAGE_TITLE, AgGridUtility, WpEtEnrollment } from '../shared';
import { CommonUtility, ServerConstantsService, DataService, APP_DATE_FORMAT } from '../shared';
import { ReferenceTableService } from '../reference-table.service';
import { NotificationsService } from 'angular2-notifications';
import * as $ from 'jquery';
import 'jquery-ui/ui/widgets/datepicker';
import { NumericEditorComponent } from "../shared/components/numeric-editor.component";


@Component({
  selector: 'app-provider-determination',
  templateUrl: './provider-determination.component.html',
  styleUrls: ['./provider-determination.component.scss'],
  host: {
    '(window:resize)': 'onResize($event)'
  }
})
export class ProviderDeterminationComponent implements OnInit, CanComponentDeactivate {
  @ViewChild('headerText') headerText:ElementRef;
  AUDIT_ENTITY_ID: string = AUDIT_ENTITY_ID;
  AUDIT_ENTITY_COLUMN_DEFS: string = AUDIT_ENTITY_COLUMN_DEFS;
  AUDIT_ENTITY_TYPE: string = AUDIT_ENTITY_TYPE;
  AUDIT_PAGE_TITLE: string = AUDIT_PAGE_TITLE;

  illSuited: any;
  dateDetermined: any;
  reasonForDetermination: string;
  reasonForDeterminationSize = 0;
  wpPersonId: number;
  enrollmentId;
  providerDetermination: ProviderDetermination;

  isDisabled = false;
  testsSw: String;
  tabIndex:any = "-1";
  isTests = false;

  testTypeDescJson: any;
  testTypeDescReverseJson: any;
  columnDefs: any;
  auditColumnDefs: any;
  testContext: any;
  testArray = [];


  
  userActionNotificationsMap: any;
  
  SINGLE_ROW_HEADER = SINGLE_ROW_HEADER;
  
  serverConstants: any;
  sharedData: any;
  rrReasonNotesSize: any;
  validationError = [];
  showError = false;
  isShowStyle = false;
  etEnrollment:WpEtEnrollment;
  isChangeDetected=false;
  readOnly = false;
  tabToNextCell:any;
  selectedProviderDetermination: ProviderDetermination;

  @ViewChild('resetBtn') resetBtn: ElementRef;
  @ViewChild('saveBtn') saveBtn: ElementRef;

  constructor(

    private router: Router,
    private http: HttpClient,
    private data: ReferenceTableService,
    private commonUtil: CommonUtility,
    private dateUtil: DateUtility,
    public dataService: DataService,
    private notificationService: NotificationsService,
    private serverConstantsService: ServerConstantsService,
    private agGridUtility: AgGridUtility,
    private modalPopupService: ModalPopupService,
    private canDeactivateGaurdService: CanDeactivateGuardService
  ) {
    this.serverConstants = serverConstantsService.getConstants();
    if(this.dataService.getSharedDataObject().get('ASMNT') == undefined){
      this.router.navigate(['/task']);
    }

  }

  ngOnInit() {
    console.log('Loading................');
    this.dataService.globalAccess = false;
    this.readOnly = this.dataService.getSharedDataObject().get("ASMNT").innerNavPages.find(x=> x.pageId === 'ASMTS').readOnly;
    const userActionNotifications = this.data.getValueFromSharedDataMap('USER-ACTION-NOTIFICATIONS');
    this.userActionNotificationsMap = this.commonUtil.createNativeMapFromList(userActionNotifications);

    this.sharedData = this.dataService.getSharedDataObject();

    this.wpPersonId = this.sharedData.get('wpPersonId');
     
    if (this.sharedData.get('etEnrollment') !== null && this.sharedData.get('etEnrollment') !== undefined) {
      this.enrollmentId = Number(this.sharedData.get('etEnrollment').id);
    }


    if (this.sharedData.get('selectedProviderDetermination') !== null && this.sharedData.get('selectedProviderDetermination') !== undefined) {
      this.selectedProviderDetermination = this.sharedData.get('selectedProviderDetermination');
    }

    console.log('PersonID ' +  this.wpPersonId);
    console.log('enrollmentId ' +  this.enrollmentId);
    console.log('selectedProviderDetermination ' +  this.selectedProviderDetermination);    

    if (this.selectedProviderDetermination !== null && this.selectedProviderDetermination !== undefined) {
      console.log('this.selectedProviderDetermination.isIllSuited ' +  this.selectedProviderDetermination.isIllSuited);
      console.log('this.selectedProviderDetermination.reasonForDetermination ' +  this.selectedProviderDetermination.reasonForDetermination);
      console.log('this.selectedProviderDetermination.dateDetermined ' +  this.selectedProviderDetermination.dateDetermined);   

      this.illSuited = this.selectedProviderDetermination.isIllSuited;
      this.reasonForDetermination = this.selectedProviderDetermination.reasonForDetermination;
      this.reasonForDeterminationSize = this.reasonForDetermination.length;
      this.dateDetermined = this.dateUtil.convertDateFromServer(this.selectedProviderDetermination.dateDetermined);

      this.isDisabled = true;
    } else {
      this.isDisabled = false;
    }

  }

  focusing(event){
    if(!event.shiftKey && event.keyCode==9){
      event.preventDefault();
    setTimeout(() => this.headerText.nativeElement.focus(), 0);
    this.headerText.nativeElement.click();
    }
  }

  onQuickTextChanged(event) {
    this.reasonForDeterminationSize = this.reasonForDetermination.length;
  }

  reset() {
    console.log('reset ======');
    this.illSuited = '';
    this.dateDetermined = '';
    this.reasonForDetermination = '';
    this.reasonForDeterminationSize=0;
  }

  restrictSpecial(event){
    if((/[<>{}]/.test(event.key))){
      event.returnValue = false;
      return;
     }
      event.returnValue = true;
  }

  focusReset(e: KeyboardEvent) {
    if (e.keyCode === 9 && !e.shiftKey) {
      setTimeout(() => this.resetBtn.nativeElement.focus(), 0);
    }
  }

  dataChanges() {
    this.isChangeDetected = true;
  }
  
  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean {
    if(this.isChangeDetected === true) {
      this.modalPopupService.setChangeDetected(true);
      return this.canDeactivateGaurdService.getCanDeactivateResult();
    } else {
      this.modalPopupService.setChangeDetected(false);
      return true;
    }
  };

  save() {

    console.log('save ======');
    console.log('wpPersonId ' +  this.wpPersonId);
    console.log('enrollmentId ' +  this.enrollmentId);
    console.log('illSuited ' +  this.illSuited);
    console.log('dateDetermined ' +  this.dateDetermined);
    console.log('reasonForDetermination ' +  this.reasonForDetermination);

    let providerDetermination = new ProviderDetermination(this.wpPersonId, this.enrollmentId, 
      this.illSuited, this.dateDetermined, this.reasonForDetermination);

    const request  =  Object.assign({}, providerDetermination);
    providerDetermination.dateDetermined = this.dateUtil.convertDateForServer(this.dateDetermined);
    console.log('dateDetermined ' +  providerDetermination.dateDetermined);

    const errMsg = 'Record not saved: Please review or contact Help Desk.';
   
    this.http.post(this.serverConstants.SERVER_API_URL + '/assessment-summary/providerDetermination/save', providerDetermination)
      .subscribe(
        (res: ProviderDetermination) => {
          if (res.hasOwnProperty('errorCode')) {

            console.log('this.illSuited ===' + this.illSuited );
            if(this.illSuited === 'Y'){
                this.notificationService.error('Task','Unable to send task to the eligibility system; system will retry later.');   
                //this.isDisabled=true;
            } else {
                this.notificationService.error(errMsg, this.userActionNotificationsMap.ERROR);
            }
            this.dataService.addValueToSharedDataMap('selectedProviderDetermination', null);
            this.router.navigate(['task/assessmentSummary']);

          } else {
            providerDetermination = res;
            if (providerDetermination.personId !== undefined || providerDetermination.personId != null) {
              this.notificationService.success('Successfully saved', this.userActionNotificationsMap.UPDATE);
              this.dataService.addValueToSharedDataMap('selectedProviderDetermination', null);
              this.router.navigate(['task/assessmentSummary']);
            }
          }
        },
        (response) => {
          console.log('this.illSuited ===' + this.illSuited );
            if(this.illSuited === 'Y'){
                this.notificationService.error('Task','Unable to send task to the eligibility system; system will retry later.');   
                //this.isDisabled=true;
            } else {
                this.notificationService.error(errMsg, this.userActionNotificationsMap.ERROR);
            }
            this.dataService.addValueToSharedDataMap('selectedProviderDetermination', null);
             this.router.navigate(['task/assessmentSummary']);
        }, 
        () => {
        });
  }


}

class RequestLoad {
  constructor(
    public id: number,

  ) {
  }
}

class ProviderDetermination {
  constructor(   
    public personId: Number,
    public etEnrollmentId: Number,
    public isIllSuited: string,
    public dateDetermined: any,
    public reasonForDetermination: string 

  ) {
  }
}



// WEBPACK FOOTER //
// ./src/app/provider-determination/provider-determination.component.ts